/**
 * Per petrifilm type, maps label keys to stroke color and optional UI label.
 * `color` is used for rendering; `label` is shown in the tools panel when set.
 */
const PETRIFILM_COLOR_MAP = {
  AC: {
    0: { color: "#00FF00", label: "AC-Colony" },
  },
  EB: {
    0: { color: "#00FF00", label: "EB-Colony" },
  },
  CC: {
    "r-colony": { color: "#FF0000", label: "R-Colony" },
    "b-colony": { color: "#0000FF", label: "B-Colony" },
  },
  RY: {
    0: { color: "#00FF00", label: "Yeast" },
    1: { color: "#0000FF", label: "Mold" },
  },
  EC: {
    "r-colony": { color: "#FF0000", label: "R-Colony" },
    "b-colony": { color: "#0000FF", label: "B-Colony" },
  },
  LB: {
    0: { color: "#00FF00", label: "Homo" },
    1: { color: "#0000FF", label: "Hetero" },
  },
};

/**
 * From an S3-style annotation path object, returns the final segment of `Name` without extension.
 * @param {{ Name?: string } | null | undefined} annotationPath
 * @returns {string}
 */
export const getAnnotationNameStem = (annotationPath) => {
  const name = annotationPath?.Name;
  if (!name) return "";
  const lastSegment = name.split("/").pop() || "";
  const dot = lastSegment.lastIndexOf(".");
  return dot > 0 ? lastSegment.slice(0, dot) : lastSegment;
};

/** @returns {{ color: string, label: string }} */
export const resolvePetrifilmEntry = (entry, fallbackLabel) => (
  typeof entry === "string"
    ? { color: entry, label: fallbackLabel }
    : { color: entry?.color ?? "#000000", label: entry?.label ?? fallbackLabel }
);

export default PETRIFILM_COLOR_MAP;
